// extracted by mini-css-extract-plugin
export default {"changeLink":"kM-z","disabled":"lM-z","inline":"mM-z"};